import stone from "../../../assets/images/vendor-discovery-icon.svg";
import blue from "../../../assets/images/vendor-discovery-icon-blue.svg";
import white from "../../../assets/images/vendor-discovery-icon-white.svg";
import bronze from "../../../assets/images/vendor-discovery-icon-bronze.svg";

type Props = {
    className?: string;
};

export default {
    Stone: ({ className }: Props) => {
        return <img src={stone} className={className ? className : "h-4 w-4"} />;
    },
    Blue: ({ className }: Props) => {
        return <img src={blue} className={className ? className : "h-4 w-4"} />;
    },
    White: ({ className }: Props) => {
        return <img src={white} className={className ? className : "h-4 w-4"} />;
    },
    Bronze: ({ className }: Props) => {
        return <img src={bronze} className={className ? className : "h-4 w-4"} />;
    }
};
